/**
 * Product capability flags — build-time defaults via `VITE_APP_ENVIRONMENT`.
 * Gates workspace/substrate/assessment surfaces separately from the public U-value calculator.
 */

function parseOptionalBooleanEnv(value: string | undefined): boolean | undefined {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
}

/** Explicit override for tests or emergency operator toggles. */
function workspaceSubstrateRoutesOverride(): boolean | undefined {
  return parseOptionalBooleanEnv(import.meta.env.VITE_ENABLE_WORKSPACE_SUBSTRATE_ROUTES);
}

/**
 * When true, workspace/project/assessment routes and substrate-backed U-value controls are available.
 * When false (production default), those surfaces are hidden or show a restrained unavailable state.
 */
export function enableWorkspaceSubstrateRoutes(): boolean {
  const override = workspaceSubstrateRoutesOverride();
  if (override !== undefined) return override;

  const env = import.meta.env.VITE_APP_ENVIRONMENT ?? 'unknown';
  if (env === 'production') return false;
  return true;
}

/** Post-login landing when `next` is absent — workspace hub or U-value calculator. */
export function getDefaultPostLoginPath(): string {
  return enableWorkspaceSubstrateRoutes() ? '/workspace' : '/u-value/calculator';
}
